import request from 'superagent'
import types from '../types'

const { api_port } = require('../../../package.json')

const { protocol, hostname } = window.location
let api_url = `${protocol}//${hostname}:${api_port}/api`
if (api_port === '') {
  api_url = `${protocol}//${hostname}/api`
}

const getServiceTypesRequested = () => ({
  type: types.GET_SERVICE_TYPES_REQUESTED,
  payload: null
})

const getServiceTypesFulfilled = (data) => ({
  type: types.GET_SERVICE_TYPES_FULFILLED,
  payload: data
})

const getServiceTypesRejected = (error) => ({
  type: types.GET_SERVICE_TYPES_REJECTED,
  payload: error
})

export const getServiceTypes = (token: string) => {
  return (dispatch: any) => {
    dispatch(getServiceTypesRequested())
    request
      .get(`${api_url}/servicetypes`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .then((response) => {
        dispatch(getServiceTypesFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getServiceTypesRejected(error))
      })
  }
}